@import 'styles/mixins';
@import 'styles/variables';

.container {
  position: relative;
  height: 100%;
  width: 100%;
}

.labelContainer {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 1;
  top: 0;
  left: 0;
  right: 0;
  align-items: center;
  &.emptyImage {
    align-items: flex-end;
  }
}

.label {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.fileUploadButton {
  display: flex;
  border-radius: 50%;
  &.hovered,
  &.focusVisible {
    background: rgba($almanac-black, 0.2);
  }
}

.fileRemoveButton {
  display: flex;
  border-radius: 4px;
  &.hovered,
  &.focusVisible {
    background: rgba($almanac-black, 0.2);
  }
}

.removeButtonContainer {
  display: flex;
  align-items: space-between;
}

.removeIcon {
  margin: 0;
  padding: 0;
  background: none !important;
}

.cropperWrapper {
  background-color: $white;
  position: relative;
  width: 320px;
  height: 320px;
  margin: 0 auto;
  .cropperContainer {
    width: 320px;
    height: 320px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.cropControls {
  background-color: $white;
  align-items: center;
  justify-content: space-between;
  padding: 24px 64px 0px;
}

.zoomContainer {
  @include inter-medium;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  font-size: 14px;
  line-height: 31px;
}

.cropperModalTitle {
  @include xl-semibold;
}

.zoomCueWrapper {
  flex: 1 1;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  .icon {
    @include xl-semibold;
    letter-spacing: -0.01em;
    color: $grey-40;
  }
  .text {
    @include md-medium;
    color: $grey-40;
  }
}

.zoomSlider {
  width: 100%;
}

.buttonContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;

  > * {
    height: 40px;
    width: auto;
  }

  > * + * {
    margin-left: 10px;
  }

  .cancelButton {
    border: 1px solid $grey-10;
    box-shadow: 0px 2px 3px $grey-5;
    padding: 14px 20px;
  }

  .saveButton {
    padding: 14px 20px;
  }
}

.hide {
  display: none;
}

.modalCloseIcon {
  fill: $black;
  margin-top: 18px;
}

.zoomInfoText {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  @include md-medium;
  color: $grey-5;
  text-align: center;
  opacity: 0.5;
}

.cropperModal {
  :global .ant-modal-body {
    padding: 32px 0px 48px;
  }
  :global .ant-slider-rail {
    height: 8px;
    border-radius: 80px;
    background-color: $grey-10;
  }
  :global .ant-modal-content {
    border-radius: 16px;
  }
  :global .ant-modal-header {
    background-color: transparent;
  }
}
